import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileText, Download, Eye, Loader2 } from "lucide-react";

export function downloadText(filename, text) {
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export default function LopdDocuments({ documents }) {
  const [doc, setDoc] = useState(null);
  const [loadingKey, setLoadingKey] = useState(null);

  const open = async (key) => {
    setLoadingKey(key);
    try {
      const { data } = await api.get(`/lopd/document/${key}`);
      setDoc(data);
    } catch { toast.error("No se pudo cargar el documento"); }
    finally { setLoadingKey(null); }
  };

  const fetchAndDownload = async (key, title) => {
    setLoadingKey(key);
    try {
      const { data } = await api.get(`/lopd/document/${key}`);
      downloadText(`${title.replace(/\s+/g, "_")}.txt`, data.content);
      toast.success("Documento descargado");
    } catch { toast.error("Error al descargar"); }
    finally { setLoadingKey(null); }
  };

  return (
    <>
      <div className="grid sm:grid-cols-2 gap-3">
        {documents.map((d) => (
          <div key={d.key} data-testid={`lopd-doc-${d.key}`} className="flex items-center gap-3 p-4 rounded-xl border border-slate-200 bg-white hover:shadow-sm transition-all">
            <div className="h-10 w-10 rounded-xl bg-sky-50 flex items-center justify-center shrink-0"><FileText className="h-5 w-5 text-sky-500" /></div>
            <div className="flex-1 min-w-0"><div className="font-medium text-slate-800 text-sm truncate">{d.title}</div></div>
            <div className="flex gap-1">
              <Button size="icon" variant="ghost" onClick={() => open(d.key)} disabled={loadingKey === d.key} data-testid={`view-doc-${d.key}`} title="Ver"><Eye className="h-4 w-4" /></Button>
              <Button size="icon" variant="ghost" onClick={() => fetchAndDownload(d.key, d.title)} disabled={loadingKey === d.key} data-testid={`download-doc-${d.key}`} title="Descargar">{loadingKey === d.key ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}</Button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={!!doc} onOpenChange={() => setDoc(null)}>
        <DialogContent className="sm:max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader><DialogTitle className="font-heading">{doc?.title}</DialogTitle></DialogHeader>
          <pre className="whitespace-pre-wrap font-sans text-sm text-slate-600 leading-relaxed">{doc?.content}</pre>
          <Button onClick={() => downloadText(`${doc.title.replace(/\s+/g, "_")}.txt`, doc.content)} className="brand-btn w-fit"><Download className="h-4 w-4 mr-2" /> Descargar</Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
